import type { UseMutationResult } from 'react-query';
import { useMutation } from 'react-query';

import * as highlightsApi from '@hotjar/webapp/domains/highlights/api';
import { queryClient } from '@hotjar/webapp/utils/react-query';
import type { UIPosition } from '@hotjar/webapp/domains/highlights/api';
import type { AxiosError } from 'axios';

export function useSetHighlightStatus(
  siteId: string,
): UseMutationResult<
  void,
  AxiosError,
  { highlightId: string; solved: boolean; uiPosition?: UIPosition }
> {
  return useMutation(
    ({ highlightId, solved, uiPosition }) =>
      highlightsApi.setHighlightSolvedStatus(siteId, highlightId, { solved, uiPosition }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(highlightsApi.HIGHLIGHTS_LIST_QUERY_KEY);
        queryClient.invalidateQueries(highlightsApi.HEATMAP_HIGHLIGHTS_LIST_QUERY_KEY);
        queryClient.invalidateQueries(highlightsApi.RECORDING_HIGHLIGHTS_LIST_QUERY_KEY);
        queryClient.invalidateQueries(highlightsApi.SINGLE_HIGHLIGHT_QUERY_KEY);
      },
    },
  );
}
